import { render, staticRenderFns } from "./luckWheelInfo.vue?vue&type=template&id=7b368b42&scoped=true"
import script from "./luckWheelInfo.vue?vue&type=script&lang=js"
export * from "./luckWheelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b368b42",
  null
  
)

export default component.exports